export default "__VITE_ASSET__B4fV$vB5__"